<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="!saving"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  [header]="title"
  [style]="{ width: '600px' }"
  [breakpoints]="{ '640px': '95vw' }"
  styleClass="guarantor-contact-dialog"
>
  <form class="guarantor-body" [formGroup]="form" (ngSubmit)="save()">
    <p class="guarantor-hint">
      Persona o empresa que respalda el arrendamiento del cliente. Cuenta para el colateral de la calculadora de riesgo.
    </p>

    <div class="field">
      <span class="field-label" id="guarantor-person-type">Tipo de persona</span>
      <p-selectButton
        formControlName="personType"
        [options]="personTypes"
        optionLabel="label"
        optionValue="value"
        ariaLabelledBy="guarantor-person-type"
      ></p-selectButton>
    </div>

    <div class="field">
      <label for="guarantor-relationship">Relación con el cliente</label>
      <p-dropdown
        inputId="guarantor-relationship"
        formControlName="relationship"
        [options]="relationships"
        optionLabel="label"
        optionValue="value"
        [autoDisplayFirst]="false"
        placeholder="Elige la relación"
        appendTo="body"
        [style]="{ width: '100%' }"
      ></p-dropdown>
      <small class="p-error" *ngIf="errorOf('relationship') as message">{{ message }}</small>
    </div>

    <ng-container *ngIf="personType === 'PF'; else companyFields">
      <div class="field-row">
        <div class="field">
          <label for="guarantor-first-name">Nombre(s)</label>
          <input pInputText id="guarantor-first-name" formControlName="firstName" autocomplete="off" />
          <small class="p-error" *ngIf="errorOf('firstName') as message">{{ message }}</small>
        </div>
        <div class="field">
          <label for="guarantor-last-name">Apellido paterno</label>
          <input pInputText id="guarantor-last-name" formControlName="lastName" autocomplete="off" />
          <small class="p-error" *ngIf="errorOf('lastName') as message">{{ message }}</small>
        </div>
      </div>
      <div class="field-row">
        <div class="field">
          <label for="guarantor-middle-name">Apellido materno <span class="optional">(opcional)</span></label>
          <input pInputText id="guarantor-middle-name" formControlName="middleName" autocomplete="off" />
        </div>
        <div class="field">
          <label for="guarantor-curp">CURP <span class="optional">(opcional)</span></label>
          <input pInputText id="guarantor-curp" formControlName="curp" maxlength="18" autocomplete="off" class="uppercase" />
          <small class="p-error" *ngIf="errorOf('curp') as message">{{ message }}</small>
        </div>
      </div>
    </ng-container>
    <ng-template #companyFields>
      <div class="field">
        <label for="guarantor-business-name">Razón social</label>
        <input pInputText id="guarantor-business-name" formControlName="businessName" autocomplete="off" />
        <small class="p-error" *ngIf="errorOf('businessName') as message">{{ message }}</small>
      </div>
    </ng-template>

    <div class="field-row">
      <div class="field">
        <label for="guarantor-rfc"
          >RFC <span class="optional">({{ personType === 'PM' ? 12 : 13 }} caracteres)</span></label
        >
        <input
          pInputText
          id="guarantor-rfc"
          formControlName="rfc"
          [maxlength]="personType === 'PM' ? 12 : 13"
          autocomplete="off"
          class="uppercase"
        />
        <small class="p-error" *ngIf="errorOf('rfc') as message">{{ message }}</small>
      </div>
      <div class="field">
        <label for="guarantor-phone">Celular</label>
        <input pInputText id="guarantor-phone" formControlName="phone" inputmode="numeric" maxlength="10" autocomplete="off" />
        <small class="p-error" *ngIf="errorOf('phone') as message">{{ message }}</small>
      </div>
    </div>

    <div class="field">
      <label for="guarantor-email">Correo <span class="optional">(opcional)</span></label>
      <input pInputText id="guarantor-email" type="email" formControlName="email" autocomplete="off" />
      <small class="p-error" *ngIf="errorOf('email') as message">{{ message }}</small>
    </div>

    <div class="server-error" role="alert" *ngIf="serverError">
      <i class="pi pi-exclamation-circle"></i>
      <span>{{ serverError }}</span>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      type="button"
      label="Cancelar"
      icon="pi pi-times"
      class="p-button-outlined"
      (click)="close()"
      [disabled]="saving"
    ></button>
    <button
      pButton
      pRipple
      type="button"
      label="Guardar"
      icon="pi pi-check"
      (click)="save()"
      [disabled]="saving"
      [loading]="saving"
    ></button>
  </ng-template>
</p-dialog>
